import React, { useState, useEffect } from "react";
import axios from "axios";
import { Receipt, Download, Loader2, FileText, Euro } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function LeMieFatture() {
  const [fatture, setFatture] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/api/me/fatture`, { withCredentials: true })
      .then((r) => setFatture(r.data || []))
      .catch(() => setFatture([]))
      .finally(() => setLoading(false));
  }, []);

  const download = (numero) => {
    window.open(`${API}/api/me/fatture/${numero}.pdf`, "_blank");
  };

  const totale = fatture.reduce((sum, f) => sum + (f.importo || 0), 0);

  return (
    <div data-testid="me-fatture" className="rounded-2xl border border-slate-200 bg-white p-6">
      <div className="flex items-start justify-between gap-4 flex-wrap mb-5">
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-xl bg-[#102a6b] text-white flex items-center justify-center">
            <Receipt className="h-5 w-5" />
          </div>
          <div>
            <div className="text-[10.5px] uppercase tracking-[0.18em] font-extrabold text-[#102a6b]">Area Fatture</div>
            <h2 className="text-xl font-extrabold text-[#0a1f55]">Le mie ricevute e fatture</h2>
          </div>
        </div>
        {fatture.length > 0 && (
          <div className="rounded-xl bg-slate-50 border border-slate-200 px-4 py-2 text-right">
            <div className="text-[10.5px] uppercase tracking-wider font-extrabold text-slate-500">Totale pagato</div>
            <div className="text-lg font-extrabold text-[#0a1f55]">€ {totale.toFixed(2)}</div>
          </div>
        )}
      </div>

      {loading ? (
        <div className="flex items-center gap-2 text-slate-500 py-6"><Loader2 className="h-4 w-4 animate-spin" /> Caricamento…</div>
      ) : fatture.length === 0 ? (
        <div className="text-center py-10 text-slate-500">
          <FileText className="h-10 w-10 mx-auto mb-3 opacity-40" />
          <p className="font-semibold">Nessuna fattura ancora emessa</p>
          <p className="text-[12.5px] mt-1">Le tue ricevute compariranno qui dopo il primo pagamento.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {fatture.map((f) => (
            <div key={f.numero} data-testid={`fattura-${f.numero}`}
              className="rounded-xl border border-slate-200 p-3 flex items-center gap-3 hover:border-[#102a6b]/40 transition-colors flex-wrap">
              <div className="h-10 w-10 rounded-lg bg-emerald-100 text-emerald-700 flex items-center justify-center flex-shrink-0">
                <Euro className="h-5 w-5" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-extrabold text-[#0a1f55] text-[14px] font-mono">{f.numero}</div>
                <div className="text-[12px] text-slate-500">{f.package_nome}</div>
                <div className="text-[11.5px] text-slate-400">{new Date(f.created_at).toLocaleString("it-IT")}</div>
              </div>
              <div className="text-right">
                <div className="text-lg font-extrabold text-[#0a1f55]">€ {(f.importo || 0).toFixed(2)}</div>
              </div>
              <button
                type="button"
                onClick={() => download(f.numero)}
                data-testid={`scarica-${f.numero}`}
                className="h-9 px-3 rounded-lg bg-[#102a6b] hover:bg-[#0a1f55] text-white text-[12.5px] font-bold inline-flex items-center gap-1.5"
              >
                <Download className="h-3.5 w-3.5" /> PDF
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
